export const UmbrellaLogo = ({ size = 28, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}
       xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M24 4C13 4 4 12.5 3 23.5c-.1 1 .9 1.6 1.7 1.1C7 23.2 9.4 22.3 12 22.3s5 .9 7.3 2.3c.4.3 1 .3 1.4 0C23 23.2 25.4 22.3 28 22.3s5 .9 7.3 2.3c.4.3 1 .3 1.4 0 2.3-1.4 4.7-2.3 7.3-2.3s5 .9 7.3 2.3c.8.5 1.8-.1 1.7-1.1C44 12.5 35 4 24 4Z" fill="currentColor"/>
    <path d="M24 22.5v16.8a4.7 4.7 0 0 1-9.4 0" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    <circle cx="24" cy="6.5" r="2.4" fill="currentColor"/>
  </svg>
);

export default UmbrellaLogo;
